export default __webpack_public_path__ + "static/media/hiw_3.840faef9.svg";